/**
 * LeaveTypeService
 * Service for LeaveType entity operations
 * Route: api/leavetypes
 */
import { CrudService } from '../base/CrudService';
/**
 * LeaveTypeService
 * Handles leave type CRUD operations
 */
export class LeaveTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaveTypeService.DEFAULT_SERVICE_PATH,
            basePath: LeaveTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaveTypeService.DEFAULT_SERVICE_PATH = 'hr';
LeaveTypeService.BASE_PATH = 'api/leavetypes';
//# sourceMappingURL=LeaveTypeService.js.map